import React from 'react';
import cn from 'classnames';

import styles from './ReprocessFlow.module.scss';

export type ReprocessStep = 'assets' | 'outputs' | 'review';

export const REPROCESS_STEPS: { id: ReprocessStep; label: string }[] = [
  { id: 'assets', label: 'Assets' },
  { id: 'outputs', label: 'Outputs' },
  { id: 'review', label: 'Review' },
];

export const StepIndicator: React.FC<{ current: ReprocessStep }> = ({ current }) => {
  const index = REPROCESS_STEPS.findIndex((s) => s.id === current);
  return (
    <ol className={styles.steps} aria-label="Progress">
      {REPROCESS_STEPS.map((s, i) => (
        <li
          key={s.id}
          className={cn(styles.step, { [styles.stepDone]: i < index, [styles.stepOn]: i === index })}
          aria-current={i === index ? 'step' : undefined}
        >
          <span className={styles.stepNum}>{i + 1}</span>
          {s.label}
        </li>
      ))}
    </ol>
  );
};

export default StepIndicator;
